module.exports = __webpack_public_path__ + "img/GreenEmail.da7458ec.svg";